const UNDECIDED_INVITE_STATUSES = new Set(['needs_action', 'decision_pending']);

export type MeetingInviteResponseWindow = {
  /** The invite is still open for a response, using the same end-time rule as the RSVP writer. */
  pending: boolean;
  /** A pending invite whose meeting has conclusively ended. */
  expired: boolean;
};

/**
 * Calendar timestamps are absolute instants. Compare the canonical meeting
 * end with the current instant, matching CalendarInviteResponseService: an
 * RSVP remains possible during an ongoing meeting and closes at endTime.
 * Missing or invalid end times stay unknown rather than being called expired.
 */
export function meetingInviteResponseWindow(
  inviteStatus: unknown,
  endTime: unknown,
  reference = new Date(),
): MeetingInviteResponseWindow {
  const undecided = UNDECIDED_INVITE_STATUSES.has(String(inviteStatus ?? '').trim().toLowerCase());
  if (!undecided) return { pending: false, expired: false };

  const endAt = endTime == null ? Number.NaN : new Date(String(endTime)).getTime();
  const expired = Number.isFinite(endAt) && endAt <= reference.getTime();
  return { pending: !expired, expired };
}
